import script from "./pp-draw-numbers-accordion.vue?vue&type=script&lang=ts&setup=true"
export * from "./pp-draw-numbers-accordion.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__